import * as Sentry from "@sentry/react";
import { browserTracingIntegration, replayIntegration } from "@sentry/browser";

export const initializeErrorTracking = () => {
    Sentry.init({
        dsn: "https://a4d87096e66584a8fa7485b92002b5bd@o4505440745881600.ingest.us.sentry.io/4508430347141120",
        integrations: [
            browserTracingIntegration(),
            replayIntegration(),
        ],
        environment: process.env.NODE_ENV,
        tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/api-portfmat-prod-fwd8fbeef5augzcw\.canadacentral-01\.azurewebsites\.net\/api/
        ],
        replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
        replaysOnErrorSampleRate: 1.0,
        // debug: process.env.NODE_ENV === 'development',
    });
};